import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../../../core'
import * as source from '../source'

export const RESOURCE = {
  payload: {
    canBeOptional: true,
    context: core.dms.models.Attribute.Id.Context.from({
      context: source.RESOURCE.payload.dimension.partialId,
      partialId: source.RESOURCE.payload.partialId,
      type: core.dms.models.Type.Entity,
    }),
    description: 'Link to the external source',
    isOptional: false,
    name: 'Url',
    partialId: PartialId.Standard.create('url'),
    type: core.common.value.types.Intrinsic.Text,
  },
  type: core.quiver.Resource.Type.DmsAttribute,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsAttribute>
